export class HomeUrl {
    public static readonly accountInfo = "/api/v1/my-account";
    public static readonly logout: string = "/api/v1/logout";
    public static readonly notification = "/api/v1/get-notification";
    public static readonly devicePlayer = "/api/v1/post-device-player";
    public static readonly acceptPolicy = "/api/v1/accept-policy";
}
